var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-container" },
    [
      _c(
        "BjDrawerForm",
        {
          ref: "BjDrawerForm",
          attrs: { form: _vm.form, rules: _vm.rules, "label-width": "120px" },
          on: { handleConfirm: _vm.handleConfirm },
        },
        [
          _c("BjDivider", [
            _vm._v(_vm._s(_vm.$t("ChannelManagement.new.title"))),
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Account"),
                        prop: "account",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.account,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "account", $$v)
                          },
                          expression: "form.account",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.API"),
                        prop: "apiServiceUrl",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.apiServiceUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "apiServiceUrl", $$v)
                          },
                          expression: "form.apiServiceUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.app_Key"),
                        prop: "appKey",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                          type: "textarea",
                          autosize: "",
                        },
                        model: {
                          value: _vm.form.appKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appKey", $$v)
                          },
                          expression: "form.appKey",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.appSecret"),
                        prop: "appSecret",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                          type: "textarea",
                          autosize: "",
                        },
                        model: {
                          value: _vm.form.appSecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appSecret", $$v)
                          },
                          expression: "form.appSecret",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.name"),
                        prop: "appName",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.appName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "appName", $$v)
                          },
                          expression: "form.appName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.type"),
                        prop: "appType",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "full-width",
                          attrs: {
                            placeholder: _vm.$t("chooseText"),
                            clearable: "",
                          },
                          model: {
                            value: _vm.form.appType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "appType", $$v)
                            },
                            expression: "form.appType",
                          },
                        },
                        _vm._l(_vm.appTypeOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Authorizable"),
                        prop: "authAccount",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.authAccount,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "authAccount", $$v)
                          },
                          expression: "form.authAccount",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.address"),
                        prop: "authUrl",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.authUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "authUrl", $$v)
                          },
                          expression: "form.authUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Callback"),
                        prop: "callBackUrl",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.callBackUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "callBackUrl", $$v)
                          },
                          expression: "form.callBackUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Other"),
                        prop: "otherUrl",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.otherUrl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "otherUrl", $$v)
                          },
                          expression: "form.otherUrl",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Development"),
                        prop: "platformAddress",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.platformAddress,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "platformAddress", $$v)
                          },
                          expression: "form.platformAddress",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("ChannelThirdPartyPlatform.Remarks"),
                        prop: "remark",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.NORMAL,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                          type: "textarea",
                          autosize: "",
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }